import { render, staticRenderFns } from "./BusinessCooperation.vue?vue&type=template&id=a94e393c&scoped=true&"
import script from "./BusinessCooperation.vue?vue&type=script&lang=js&"
export * from "./BusinessCooperation.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCooperation.vue?vue&type=style&index=0&id=a94e393c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94e393c",
  null
  
)

export default component.exports